{
  "info": "Infos",
  "negative": "Erreur",
  "positive": "Succès"
}
